import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular/standalone';
import { Observable } from 'rxjs';
import { ConsoleLog } from 'src/app/models/consolelog.model';
import { ConsoleLogService } from 'src/app/services/console-log.service';
import { Clipboard } from '@capacitor/clipboard';

@Component({
    selector: 'app-console-log',
    templateUrl: './console-log.page.html',
    styleUrls: ['./console-log.page.scss'],
    standalone: false
})
export class ConsoleLogPage implements OnInit {
  public consolelog$: Observable<ConsoleLog[]>;

  constructor(
    public modalController: ModalController,
    private consolelogService: ConsoleLogService
  ) { }

  ngOnInit() {
    this.consolelog$ = this.consolelogService.consolelogs$;
  }

  async copy(text: ConsoleLog[]) {
    console.log('copying');
    await Clipboard.write({
      string: JSON.stringify(text)
    });
  }

  clear() {
    this.consolelogService.clear();
  }
  save() {

  }
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }

}
